export class Global {
   // public static readonly App_url="http://localhost:64625/"
    public static readonly App_url=""

    public static readonly App_diem_doi_tien = "diem_doi_tien";
    public static readonly App_thue_suat_vat = "thue_suat_vat";

    public static readonly App_ap_dung_tich_diem = "ap_dung_tich_diem";
    public static readonly App_tien_doi_diem = "tien_doi_diem";
    public static readonly App_ap_dung_doi_diem = "ap_dung_doi_diem";
    public static readonly App_the_bac = "the_bac"; 
    public static readonly App_the_vang = "the_vang";
    public static readonly App_the_bach_kim = "the_bach_kim";
    public static readonly App_the_kim_cuong = "the_kim_cuong";
    public static readonly App_ap_dung_tich_diem_san_pham = "ap_dung_tich_diem_san_pham";
    public static readonly App_ap_dung_tich_diem_dich_vu = "ap_dung_tich_diem_dich_vu";   

    public static readonly BASE_USER_ENDPOINT = 'api/user/';
    public static readonly BASE_DONVI_ENDPOINT = 'api/donviapi/';
    public static readonly BASE_NHACUNGCAP_ENDPOINT = 'api/nhacungcapapi/';
    public static readonly BASE_LINHVUC_ENDPOINT = 'api/linhvucapi/';
    public static readonly BASE_DANTOC_ENDPOINT = 'api/dantocapi/';
    public static readonly BASE_SECURITY_ENDPOINT = 'api/security/';
    public static readonly BASE_ROLE_ENDPOINT = 'api/role/';
    public static readonly BASE_USERROLE_ENDPOINT = 'api/userroles/';
    public static readonly BASE_HUYENTINH_ENDPOINT = 'api/huyentinhapi/';
    public static readonly BASE_ENDPOINT = 'api/BaseLayout/';
    public static readonly BASE_BC1_GETID = 'api/bc1/getbyid/';
    public static readonly BASE_BC01_GETID = 'api/bc01/getbyid/';
    public static readonly BASE_BC01_SAVE = 'api/bc01/post';
    public static readonly BASE_BC02_GETID = 'api/bc02/getbyid/';
    public static readonly BASE_BC02_SAVE = 'api/bc02/post';
    public static readonly BASE_NEWS_POST = 'api/news/post';
    public static readonly BASE_BaoCao_SAVE = 'api/baocao/run/';
    public static readonly BASE_BaoCao2_SAVE = 'api/baocao/run2/';

    public static readonly BASE_BC04_GETID = 'api/bc04mau1a/getbyid/';
    public static readonly BASE_BC04_SAVE = 'api/bc04mau1a/post';
    public static readonly BASE_BC05_GETID = 'api/bc05mau1b02/getbyid/';
    public static readonly BASE_BC05_SAVE = 'api/bc05mau1b02/post';
    public static readonly BASE_BC06_GETID = 'api/bc06mau1b05/getbyid/';
    public static readonly BASE_BC06_SAVE = 'api/bc06mau1b05/post';

    
    

}
export class BaoCao {



  // dùng chung để tải mẫu báo cáo (dùng cho chức năng tùy chỉnh báo cáo)
  public static readonly BC01_XuatMauBaoCao = 'C43BF77C-729B-4FB1-9E3C-B17FCF224BDA';
  // dùng để tải mẫu import (dùng cho chức năng nhập dữ liệu từ excel)
  public static readonly BC02_MauNhapTuExcel = '85F8063B-87A2-4CD9-849B-7E90DB5C9072';
  // dùng để xuất dữ liệu trên các lưới ra excel
  public static readonly BC03_XuatDanhSach = 'CBB9B028-4FE0-4518-8A4B-E5F16CACCAB6';
  // dùng để xuất sổ cái- hình thức nhật ký chung
  public static readonly BC04_SoCaiTaiKhoan = '4BDC6A56-C92F-4160-8655-A123890218E1';
  // dùng để xuất phiếu chứng từ
  public static readonly BC05_PhieuChungTu = '245E2024-200A-444C-ACFA-8805DE0AE59B';
  // dùng để xuất giáy rút dự toán mẫu 02a 
  public static readonly BC06_GiayRutDuToan_02a = 'A218527D-36F6-423E-BC85-C464EB800970';

    // dùng để xuất giáy rút dự toán mẫu 02b
  public static readonly BC07_GiayRutDuToan_02b = '111669E5-DB73-4B1B-920A-D73E5F09E02C';
  // dùng để xuất bảng kê thanh toán tạm ứng TT39
  public static readonly BC08_BangKeThanhToanTamUng_TT39 = '7CF94008-952E-410E-B189-22190DFDEF2B';
  // dùng để xuất giấy đề nghị thanh toán tạm ứng, ứng trước C2-03
  public static readonly BC08_02_GiayDeNghiThanhToanC2_03 = 'E13132D8-83F7-48A2-90DD-81F20C6E6EE8';


  // dùng để xuất ủy nhiệm chi chuyển khoản, chuyển tiền điện tử C4 02a/KB
  public static readonly BC08_03_UyNhiemChiC4_02a = 'EED0B703-0D0F-4A19-9D12-126C51513D65';

  // dùng cho giấy rút tiền mặt C4-09/KB
  public static readonly BC08_05_GiayRutTienMat_C4_09_KB = '29E1D4AD-847B-4F02-8ACF-F8E2B19C2729';

  // dùng cho C37-HD: Giấy đề nghị thanh toán
  
  public static readonly BC08_06_GiayDeNghiThanhToan_C37HD = 'F48213DE-03D9-445B-B8C5-F2DFE9D4CFCA';


  // dùng để xuất Bảng đối chiếu dự toán kinh phí ngân sách (Mẫu số 01-SDKP/ĐVDT)
  public static readonly BC09_BangDoiChieuDuToanNS = '7AF52398-3D2F-4FDE-9532-A78695AA8134';
// dùng để xuất Bảng đối chiếu tình hình sử dụng kinh phi (Mẫu số 02-SDKP/ĐVDT)
  public static readonly BC10_BangDoiChieuSuDungKP = '1777922D-C824-48F0-8D59-014FFAAC0E61';
// dùng để xuất Bảng xác nhận số dư tài khoản tiền gửi (Mẫu số 05-ĐCSDTK/KBNN)
  public static readonly BC11_BangXacNhanSoDuTaiKhoanTienGui = 'DD00E60A-9E00-4A39-B5A3-1DC8DA94CF91';


  public static readonly BC12_ThongKeTongHop = '47C2A1E7-B7BE-4A41-96B0-D3CA5D2F804F';
  public static readonly BC13_ThongKeCongVanNghiepVu = '4BDC6A56-C92F-4160-8655-A123890218E1';
  public static readonly BC14_ThongKeCongVanDenTheoDiaPhuong = '99496F5D-873D-4CB3-9387-A348C330FFB0';
  public static readonly BC15_ThongKeCongVanDenTheoLoaiHinhCV = 'B8BD15D9-5805-4AE6-A66B-51AEF4393978';
  public static readonly BC16_ThongKeCongVanDenTheoThoiGian = 'ECE8C9E9-E48F-4245-8733-5D5D76F4AB62';
  public static readonly BC17_ThongKeCongVanDenTheoToiDanh = '951E8C39-0AB0-4F22-914A-0829015DDE34';
  public static readonly BC18_ThongKeCongVanDenTheoLinhVuc = '9F269D4E-8BC4-4E8C-8925-32597EBED9D1';
  public static readonly BC19_ThongKeCongVanDenTheoVuViec = '3C23B951-1F36-4EC4-9029-2C11279E823E';
  public static readonly BC20_ThongKeCongVanDenTheoCongViecHC = 'D4B584C6-A3E5-4441-B07F-8807B017630A';
  public static readonly BC21_ThongKeCongVanDenTheoLoaiAn = '3CD8C834-20DA-4123-881E-E5A7B77A1A30';
  public static readonly BC22_ThongKeCongVanDenTheoQuocGia = '850DB0F0-FB95-4210-B646-9D36B69E802E';
  public static readonly BC23_ThongKeCongVanDenTheoDoKhan = '7AE62001-9E86-4C83-AA53-28F5545B995D';
  public static readonly BC24_ThongKeChuyenAn = '7EB0267F-59B9-4440-8ADE-24A54B3DEB97';
  public static readonly BC25_ThongKeSoLieuBatGiuToiPham = '0078B7D7-3A15-4B65-99EE-EA912E157247';
  public static readonly BC26_ThongKeNguoiNghienMaTuyCoHoSo = '65C9FEF8-1411-4F60-BB9C-244311336858';
  
  //public static readonly BC27_ = '';
  //public static readonly BC28_ = '';
  //public static readonly BC29_ = '';
  //public static readonly BC30_ = '';
  //public static readonly BC31_ = '';
  //public static readonly BC32_ = '';
  //public static readonly BC33_ = '';
  //public static readonly BC34_ = '';
  public static readonly BC35_BaoCaoCongVanDenTheoDonVi = 'DE4D725A-06D4-4D25-9634-24887462CC86';
  public static readonly BC36_BaoCaoCongVanDenTheoDoMat = '654FFDE9-9277-469A-B3DD-EC57567FFDA2';
  public static readonly BC37_BaoCaoCongVanDenTheoNguoiKy = 'DC4CF216-510E-4F65-B8B7-F3BAACFC531A';
  public static readonly BC38_BaoCaoCongVanDiTheoVuViec = 'AB5290C5-0FA4-4122-B261-04A81BC2A628';
  public static readonly BC39_BaoCaoCongVanDiTheoDoiTuong = '73D6DCE2-5576-412B-98E4-F9B2F3CE9659';
  public static readonly BC40_BaoCaoCongVanDiTheoLoaiToiDanh = '1995745C-2F8B-4BC1-87F6-DB91C00A3FEE';
  //public static readonly BC41_ = '';
  //public static readonly BC42_ = '';
  //public static readonly BC43_ = '';
  //public static readonly BC44_ = '';
  //public static readonly BC45_ = '';
  //public static readonly BC46_ = '';
  //public static readonly BC47_ = '';
  //public static readonly BC48_ = '';
  //public static readonly BC49_ = '';

  public static readonly BC50_BaoCaoVuViecTheoQuocGia = '4F528C26-490E-4281-A6D8-4F11D054738D';
  public static readonly BC51_BaoCaoVuViecTheoDonVi = '24931D8D-BCA4-4B79-9EF4-2E036A2947C4';
  public static readonly BC52_BaoCaoVuViecTheoLinhVuc = 'E46DDBC7-5CDE-4592-AE6D-62515D558304';
  public static readonly BC53_BaoCaoDoiTuongTheoToiDanh = '5A377C37-E0B5-4635-8180-178273912DD7';
  public static readonly BC54_BaoCaoDoiTuongTheoTinhThanh = 'EDDC9FC5-95BE-46D6-8B53-7029830C963B';
  public static readonly BC55_BaoCaoDoiTuongTheoNguoiKy = 'FD552462-B075-4B62-888D-48EEABAD4641';
  public static readonly BC56_BaoCaoDoiTuongTheoVuViec = 'F47CC968-E4A7-4C35-A861-A9510EAFBE87';
  public static readonly BC57_BaoCaoTheoNguoiPhuTrach = '087A1541-8EEE-4D36-B6EA-29E5E4077C09';
  //public static readonly BC58_ = '';
  //public static readonly BC59_ = '';
  //public static readonly BC60_ = '';
  //public static readonly BC61_ = '';
  //public static readonly BC62_ = '';
  //public static readonly BC63_ = '';
  //public static readonly BC64_ = '';

  public static readonly BC70_BaoCaoThongKeCongTacNghiepVuCoBan = '66589524-41D9-4389-8425-5F5C8760DCD0';
  public static readonly BC71_BaoCaoDanhSachCacVanBanQuyPhamPhapLuat = '1D14A06F-35CF-4996-824C-FD7606715FA5';
  public static readonly BC72_BaoCaoDanhSachCacVuViecXacMinhTheoYeuCau = 'D9CD5A32-75B7-4162-9496-8A2E9A107265';
  public static readonly BC73_BangKeCacVuAnDoDonViThuLy = 'C9E9962F-0D2C-441A-8145-801A1C242E97';
  public static readonly BC74_DanhSachTiepNhanCacDoiTuongTruyNa = '8702C998-CB06-4176-BF33-7BAFE78F8889';
  public static readonly BC75_DanhSachCacVuViecTuongTroTuPhapDaGiaiQuyet = 'B06932FA-E5C6-4E77-91D3-7DD19EC8DACD';
  public static readonly BC76_DanhSachCacVuViecVuAnHuongDanThamDinh = 'BA2807D4-CACA-4F1B-A1E7-32A95701EF04';



  public static readonly BC101_Luong_KhongThuongXuyen = '664ED2FD-86B2-48B0-BDA4-D787C3A8E868';
  public static readonly BC102_Luong_TienLuong = '89E993B3-E70A-4663-9CF9-279F0931733B';

  public static readonly BC102_Luong_BangLuongCongChuc = 'ED41BDB1-2420-4FC1-A6E9-21F84CE89376';
  public static readonly BC102_Luong_BangLuongHopDong68 = '2E046A61-9180-472C-BA03-A4E659146B29';
  public static readonly BC102_Luong_BangLuongPhuCap = '7EC80760-817C-4B2E-A986-4E13CE6C9A49';

  public static readonly BC102_Luong_BangLuongCongChuc_TruyLinh = 'D1E64C89-DA8E-46FF-95CA-84DDFB1F1EBB';
  public static readonly BC102_Luong_BangLuongHopDong68_TruyLinh = '8724039B-AA5F-483D-828C-69C8A6AD830D';
  public static readonly BC102_Luong_BangLuongPhuCap_TruyLinh = 'E3C7E52D-235A-4BE6-B4A5-D676BA23DE5A';

  public static readonly BC103_Luong_ThueTNCN = 'D3605E1B-189A-4882-A8D9-31976A1485C2';

  

  
}
